import app from 'flarum/forum/app';
const dayjs = window.dayjs;
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import PlayerStatsModal from './PlayerStatsModal';
import JokoakNavbar from '../aurrera-jokoak/JokoakNavbar';
import NagusiBackNav from '../common/NagusiBackNav';
import MatchRatingComponent from './MatchRatingComponent';
export default class MatchStatsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.searchText = '';
    this.sortColumn = 'aaScore';
    this.sortDirection = 'desc';
    this.playerStats = [];
    this.teamMatches = [];
    this.expandedMatches = {};
    this.matchVotes = {};
    this.loadingPlayerVotes = {};
    this.loadingMatchVotes = {};
    this.globalStats = {
      M: 0,
      C: 5
    };
    this.activeMatchForGame = null;
    this.loadingMatchDetails = false;
    this.teamId = m.route.param('teamId') || app.forum.attribute('nagusiMatchRatingsPrimaryTeamId') || '531';
    this.seasonParam = m.route.param('season');
    this.season = this.seasonParam ? this.seasonParam.replace('-', '/') : null;
    this.loadData(this.teamId, this.season);
  }
  loadData(teamId, season) {
    this.loading = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/player-classification/".concat(teamId),
      params: {
        season: season
      }
    }).then(response => {
      this.playerStats = app.store.pushPayload(response) || [];
      this.playerStats.forEach(p => {
        p.aaScore = parseFloat(p.attribute('aaScore')) || 0;
        p.media = parseFloat(p.attribute('media')) || 0;
        p.mediana = parseFloat(p.attribute('mediana')) || 0;
        p.partidos = p.attribute('partidos') || 0;
      });
      this.globalStats = {
        M: 0,
        C: 5
      };
      if (this.playerStats.length > 0) {
        const firstPlayer = this.playerStats[0];
        this.globalStats = {
          M: parseFloat(firstPlayer.attribute('globalM')) || 0,
          C: firstPlayer.attribute('C') || 5
        };
      }
      this.loading = false;
      m.redraw();
    }).catch(err => {
      console.error('[MatchStatsPage] Error loading player classification:', err);
      this.loading = false;
      this.error = err;
      m.redraw();
    });
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/team-matches/".concat(teamId),
      params: {
        season: season
      }
    }).then(response => {
      const matches = app.store.pushPayload(response) || [];
      this.teamMatches = matches.sort((a, b) => {
        const dateA = a.matchDate() ? new Date(a.matchDate()).getTime() : 0;
        const dateB = b.matchDate() ? new Date(b.matchDate()).getTime() : 0;
        return dateA - dateB;
      });

      // Auto-select first active rating match
      const activeMatches = this.teamMatches.filter(match => {
        const matchDate = match.matchDate();
        if (!matchDate) return false;
        const now = dayjs();
        const startsAt = dayjs(matchDate);
        const endsAt = startsAt.add(3, 'days');
        return now.isAfter(startsAt) && now.isBefore(endsAt);
      });
      if (activeMatches.length > 0) {
        this.selectMatch(activeMatches[0]);
      }
      m.redraw();
    }).catch(err => {
      console.error('[MatchStatsPage] Error loading matches:', err);
    });
  }
  selectMatch(match) {
    if (match.players() && match.players().length > 0) {
      this.activeMatchForGame = match;
      m.redraw();
      return;
    }
    this.loadingMatchDetails = true;
    this.activeMatchForGame = match;
    m.redraw();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/matches/' + match.id() + '?include=players,votes,votes.user,votes.player,bolillaVotes,bolillaVotes.user,season,team,rival'
    }).then(response => {
      app.store.pushPayload(response);
      this.activeMatchForGame = app.store.getById('nagusi_matches', match.id());
      this.loadingMatchDetails = false;
      m.redraw();
    }).catch(error => {
      console.error('Error loading match details:', error);
      this.loadingMatchDetails = false;
      m.redraw();
    });
  }
  toggleMatch(matchId) {
    if (this.expandedMatches[matchId]) {
      this.expandedMatches[matchId] = false;
      m.redraw();
      return;
    }
    if (this.matchVotes[matchId]) {
      this.expandedMatches[matchId] = true;
      m.redraw();
      return;
    }
    this.loadingMatchVotes[matchId] = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/matches/".concat(matchId, "/vote-details")
    }).then(response => {
      this.matchVotes[matchId] = app.store.pushPayload(response) || [];
      this.loadingMatchVotes[matchId] = false;
      this.expandedMatches[matchId] = true;
      m.redraw();
    }).catch(err => {
      this.loadingMatchVotes[matchId] = false;
      console.error('Error loading match votes:', err);
      m.redraw();
    });
  }
  showPlayerDetails(player) {
    const playerId = player.id();
    const openModal = votes => {
      // Group votes by match
      const matchGroups = {};
      votes.forEach(v => {
        const match = v.match();
        if (!match) return;
        const mId = match.id();
        if (!matchGroups[mId]) {
          const rival = match.rival();
          matchGroups[mId] = {
            opponent: rival ? rival.name() : match.attribute('opponent') || '',
            date: match.attribute('matchDate'),
            ratings: []
          };
        }
        matchGroups[mId].ratings.push(parseFloat(v.attribute('rating')));
      });

      // Calculate stats for each match
      const history = Object.values(matchGroups).map(group => {
        const ratings = group.ratings.sort((a, b) => a - b);
        const count = ratings.length;
        const mid = Math.floor(count / 2);
        const median = count % 2 !== 0 ? ratings[mid] : (ratings[mid - 1] + ratings[mid]) / 2;
        const mean = ratings.reduce((a, b) => a + b, 0) / count;
        return {
          opponent: group.opponent,
          date: group.date,
          mean: mean.toFixed(2),
          median: median.toFixed(2)
        };
      }).sort((a, b) => new Date(b.date) - new Date(a.date));
      app.modal.show(PlayerStatsModal, {
        player: {
          name: player.attribute('name'),
          photoUrl: player.attribute('photoUrl'),
          entityType: player.attribute('entityType'),
          average: parseFloat(player.attribute('media') || 0).toFixed(2),
          median: parseFloat(player.attribute('mediana') || 0).toFixed(2),
          aaScore: parseFloat(player.aaScore || 0).toFixed(2),
          matchCount: player.attribute('partidos'),
          history: history
        },
        globalStats: this.globalStats
      });
    };
    if (this.playerVotes && this.playerVotes[playerId]) {
      openModal(this.playerVotes[playerId]);
      return;
    }
    this.loadingPlayerVotes[playerId] = true;
    m.redraw();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/players/".concat(playerId, "/votes"),
      params: {
        season: this.season,
        teamId: this.teamId
      }
    }).then(response => {
      this.playerVotes = this.playerVotes || {};
      this.playerVotes[playerId] = app.store.pushPayload(response) || [];
      this.loadingPlayerVotes[playerId] = false;
      openModal(this.playerVotes[playerId]);
    }).catch(err => {
      this.loadingPlayerVotes[playerId] = false;
      console.error('Error loading player votes:', err);
      m.redraw();
    });
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "MatchStatsPage"
      }, m("div", {
        className: "container"
      }, m(NagusiBackNav, {
        parentUrl: "/aurrera-jokoak",
        parentLabel: "Aurrera Jokoak",
        title: "Valoraciones"
      }), m("div", {
        className: "Loading-Screen"
      }, m(LoadingIndicator, null), m("p", null, app.translator.trans('nagusi-match-ratings.forum.stats.loading')))));
    }
    if (this.error) {
      return m("div", {
        className: "MatchStatsPage"
      }, m("div", {
        className: "container"
      }, m(NagusiBackNav, {
        parentUrl: "/aurrera-jokoak",
        parentLabel: "Aurrera Jokoak",
        title: "Valoraciones"
      }), m("div", {
        className: "Error-Screen"
      }, m("i", {
        className: "fas fa-exclamation-circle"
      }), m("p", null, app.translator.trans('nagusi-match-ratings.forum.stats.error_loading') || 'Error loading statistics. Please try again later.'), m("pre", {
        style: {
          textAlign: 'left',
          background: '#f5f5f5',
          padding: '10px',
          overflow: 'auto'
        }
      }, this.error), m(Button, {
        className: "Button Button--primary",
        onclick: () => window.location.reload()
      }, app.translator.trans('core.forum.index_sort.latest_button')))));
    }
    const filteredPlayers = this.playerStats.filter(p => (!p.attribute('entityType') || p.attribute('entityType') === 'player') && (p.attribute('name') || '').toLowerCase().includes(this.searchText.toLowerCase()));
    const filteredOthers = this.playerStats.filter(p => p.attribute('entityType') && p.attribute('entityType') !== 'player' && (p.attribute('name') || '').toLowerCase().includes(this.searchText.toLowerCase())).sort((a, b) => (parseFloat(b.attribute('media')) || 0) - (parseFloat(a.attribute('media')) || 0));
    const filteredMatches = this.teamMatches.filter(m => {
      const rival = m.rival();
      const opponentName = rival ? rival.name() : m.attribute('opponent') || '';
      return opponentName.toLowerCase().includes(this.searchText.toLowerCase());
    });
    const activeRatingMatches = this.teamMatches.filter(match => {
      const matchDate = match.matchDate();
      if (!matchDate) return false;
      const now = dayjs();
      const startsAt = dayjs(matchDate);
      const endsAt = startsAt.add(3, 'days');
      return now.isAfter(startsAt) && now.isBefore(endsAt);
    }).sort((a, b) => new Date(b.matchDate()).getTime() - new Date(a.matchDate()).getTime());
    const currentPath = m.route.get() || '';
    const isVoteMode = currentPath.includes('/valorar');
    const season = this.seasonParam || '2025-2026';
    return m("div", {
      className: "MatchStatsPage"
    }, m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      parentUrl: "/aurrera-jokoak",
      parentLabel: "Aurrera Jokoak",
      title: "Valoraciones"
    }), m("h2", {
      className: "MatchStatsPage-Title"
    }, "Valoraci\xF3n a jugadores"), m(JokoakNavbar, null), m("div", {
      className: "JokoakSubmenu"
    }, m(Link, {
      href: "/valoracion-".concat(app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic', "/").concat(season, "/clasificacion"),
      className: "JokoakSubmenu-link ".concat(!isVoteMode ? 'active' : '')
    }, "\uD83D\uDCCA Clasificaci\xF3n"), m(Link, {
      href: "/valoracion-".concat(app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic', "/").concat(season, "/valorar"),
      className: "JokoakSubmenu-link ".concat(isVoteMode ? 'active' : '')
    }, "\uD83C\uDFC3\u200D\u2642\uFE0F Valorar")), isVoteMode ? activeRatingMatches.length > 0 ? m("div", {
      id: "rating-vote",
      className: "ActiveGameSection RatingActiveSection BolillaVoteHeader",
      style: "margin-bottom: 40px;"
    }, m("h3", {
      style: "font-size: 1.4em; font-weight: 800; margin: 0 0 20px 0; display: flex; align-items: center; gap: 10px;"
    }, m("span", {
      style: "font-size: 1.2em;"
    }, "\uD83C\uDFC3\u200D\u2642\uFE0F"), "Valorar Jugadores del \xDAltimo Partido"), activeRatingMatches.length > 1 && m("div", {
      className: "ActiveMatches-Tabs",
      style: "display: flex; gap: 10px; margin-bottom: 25px; overflow-x: auto; padding-bottom: 5px;"
    }, activeRatingMatches.map(match => m("button", {
      className: "Button match-selection-btn ".concat(this.activeMatchForGame && this.activeMatchForGame.id() === match.id() ? 'selected-rating' : ''),
      onclick: () => this.selectMatch(match),
      style: "border-radius: 20px; font-weight: bold; padding: 8px 16px;"
    }, match.renderName()))), this.activeMatchForGame && m("div", {
      className: "ActiveMatchWidget-Wrapper",
      style: "animation: fadeIn 0.4s;"
    }, this.loadingMatchDetails ? m("div", {
      style: "text-align: center; padding: 20px;"
    }, m(LoadingIndicator, null)) : m(MatchRatingComponent, {
      match: this.activeMatchForGame
    }))) : m("div", {
      className: "ActiveGameSection BolillaNoActiveGame"
    }, m("span", {
      style: "font-size: 3em;"
    }, "\uD83C\uDFC3\u200D\u2642\uFE0F"), m("h3", {
      style: "font-weight: 800; margin-top: 15px;"
    }, "No hay valoraciones activas"), m("p", {
      style: "margin-bottom: 20px;"
    }, "Todos los partidos ya han cerrado su periodo de votaci\xF3n o no hay partidos programados."), m(Link, {
      href: "/valoracion-".concat(app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic', "/").concat(season, "/clasificacion"),
      className: "Button Button--primary",
      style: "border-radius: 20px; font-weight: bold; padding: 8px 24px;"
    }, "\uD83D\uDCCA Ver Clasificaci\xF3n General")) : m("div", {
      id: "rating-classification"
    }, this.playerStats.length > 0 && this.renderSeasonOverview(), m("div", {
      className: "Stats-Main-Content"
    }, m("div", {
      className: "Stats-Filters",
      style: "margin-bottom: 20px;"
    }, m("div", {
      className: "Search-Wrapper"
    }, m("i", {
      className: "fas fa-search"
    }), m("input", {
      type: "text",
      className: "FormControl",
      placeholder: app.translator.trans('nagusi-match-ratings.forum.stats.search_placeholder'),
      value: this.searchText,
      oninput: e => this.searchText = e.target.value
    }))), filteredPlayers.length === 0 && filteredOthers.length === 0 ? m("div", {
      className: "No-Results",
      style: "text-align: center; padding: 30px; border-radius: 12px; margin-bottom: 25px;"
    }, m("i", {
      className: "fas fa-chart-bar",
      style: "font-size: 2.5em; opacity: 0.5; margin-bottom: 15px; display: block;"
    }), m("p", {
      style: "font-weight: bold; margin: 0;"
    }, "No hay estad\xEDsticas de valoraciones registradas para esta temporada todav\xEDa.")) : m("div", null, filteredPlayers.length > 0 && this.renderPlayerTable(filteredPlayers), filteredOthers.length > 0 && this.renderOthersTable(filteredOthers)), this.teamMatches.length > 0 ? this.renderMatchesSection(filteredMatches) : m("div", {
      className: "No-Results",
      style: "text-align: center; padding: 30px; border-radius: 12px; margin-top: 20px;"
    }, m("i", {
      className: "fas fa-calendar-times",
      style: "font-size: 2.5em; opacity: 0.5; margin-bottom: 15px; display: block;"
    }), m("p", {
      style: "font-weight: bold; margin: 0;"
    }, "No hay partidos registrados para esta temporada."))))));
  }
  renderSeasonOverview() {
    const topPlayers = this.playerStats.filter(p => !p.attribute('entityType') || p.attribute('entityType') === 'player').slice(0, 3);
    return m("div", {
      className: "SeasonOverview"
    }, m("div", {
      className: "Overview-Header"
    }, m("h3", null, app.translator.trans('nagusi-match-ratings.forum.stats.overview'))), m("div", {
      className: "Podium"
    }, topPlayers[1] && this.renderPodiumPlayer(topPlayers[1], 2), topPlayers[0] && this.renderPodiumPlayer(topPlayers[0], 1), topPlayers[2] && this.renderPodiumPlayer(topPlayers[2], 3)), this.playerStats.length > 0 && m("div", {
      className: "Season-Statistics"
    }, m("div", {
      className: "Statistics-Explanation"
    }, m("p", null, m("i", {
      className: "fas fa-info-circle"
    }), " ", app.translator.trans('nagusi-match-ratings.forum.stats.explanation')))));
  }
  renderPodiumPlayer(player, position) {
    const photoUrl = player.attribute('photoUrl');
    const name = player.attribute('name');
    const pathId = 'txapela-podium-path-' + Math.random().toString(36).substr(2, 9);
    return m("div", {
      className: "Podium-Player pos-".concat(position),
      key: player.id()
    }, m("div", {
      className: "Player-Avatar-Wrapper"
    }, photoUrl ? m("img", {
      src: photoUrl,
      alt: name
    }) : m("div", {
      className: "Player-Avatar-Placeholder"
    }, name.substring(0, 1)), m("div", {
      className: "Rank-Badge"
    }, position), position === 1 && m("div", {
      className: "MVP-Txapela"
    }, m("svg", {
      viewBox: "0 0 100 45",
      className: "txapela-svg",
      xmlns: "http://www.w3.org/2000/svg"
    }, m("defs", null, m("path", {
      id: pathId,
      d: "M 8,24 Q 50,13 92,24",
      fill: "none",
      stroke: "none"
    })), m("ellipse", {
      cx: "50",
      cy: "30",
      rx: "35",
      ry: "8",
      fill: "rgba(0, 0, 0, 0.25)"
    }), m("path", {
      d: "M 8,24 C 8,6 92,6 92,24 C 92,36 8,36 8,24 Z",
      fill: "#1e1e1f"
    }), m("path", {
      d: "M 20,28 Q 50,34 80,28 Q 50,23 20,28 Z",
      fill: "#131314"
    }), m("path", {
      d: "M 50,11 Q 50,4 51,2 Q 53,4 53,11 Z",
      fill: "#1e1e1f"
    }), m("text", {
      fill: "#ffffff",
      "font-size": "5",
      "font-weight": "900",
      "letter-spacing": "0.8",
      stroke: "#ffd700",
      "stroke-width": "0.15px",
      dy: "1.5",
      "text-anchor": "middle",
      textAnchor: "middle"
    }, m("textPath", {
      href: "#".concat(pathId),
      startOffset: "50%",
      "text-anchor": "middle",
      textAnchor: "middle"
    }, "TXAPELDUN"))))), m("div", {
      className: "Player-Details"
    }, m("span", {
      className: "Player-Name"
    }, name), m("div", {
      className: "Player-Score-Container"
    }, m("span", {
      className: "Player-Average"
    }, player.aaScore.toFixed(2)), m("span", {
      className: "Label"
    }, app.translator.trans('nagusi-match-ratings.forum.modal.avg_label')))));
  }
  renderPlayerTable(players) {
    return m("div", {
      className: "PlayerClassificationWrapper"
    }, m("div", {
      className: "PlayerClassification-Header"
    }, m("span", null, "CLASIFICACI\xD3N COMPLETA")), m("table", {
      className: "Table PlayerTable"
    }, m("thead", null, m("tr", null, m("th", {
      className: "col-player"
    }, "JUGADOR ", m("i", {
      className: "fas fa-sort"
    })), m("th", {
      className: "col-stat"
    }, "PUNTUACI\xD3N AA ", m("i", {
      className: "fas fa-sort"
    })), m("th", {
      className: "col-stat"
    }, "MEDIA REAL ", m("i", {
      className: "fas fa-sort"
    })), m("th", {
      className: "col-stat"
    }, "MEDIANA ", m("i", {
      className: "fas fa-sort"
    })), m("th", {
      className: "col-stat"
    }, "PARTIDOS ", m("i", {
      className: "fas fa-sort"
    })))), m("tbody", null, players.map(p => m("tr", {
      key: p.id(),
      onclick: () => this.showPlayerDetails(p),
      className: "PlayerTable-Row"
    }, m("td", {
      className: "col-player"
    }, m("div", {
      className: "PlayerTable-PlayerInfo"
    }, m("div", {
      className: "PlayerTable-Avatar"
    }, p.attribute('photoUrl') ? m("img", {
      src: p.attribute('photoUrl'),
      alt: p.attribute('name')
    }) : m("span", null, (p.attribute('name') || 'P')[0])), m("span", {
      className: "PlayerTable-Name"
    }, p.attribute('name')))), m("td", {
      className: "col-stat score"
    }, parseFloat(p.aaScore || 0).toFixed(2)), m("td", {
      className: "col-stat"
    }, parseFloat(p.attribute('media') || 0).toFixed(2)), m("td", {
      className: "col-stat"
    }, parseFloat(p.attribute('mediana') || 0).toFixed(1)), m("td", {
      className: "col-stat"
    }, m("span", {
      className: "PlayerTable-Partidos"
    }, p.attribute('partidos') || 0)))))));
  }
  renderOthersTable(others) {
    return m("div", {
      className: "PlayerClassificationWrapper OthersClassificationWrapper",
      style: "margin-top: 30px;"
    }, m("div", {
      className: "PlayerClassification-Header"
    }, m("span", null, app.translator.trans('nagusi-match-ratings.forum.stats.coach_team_title') || 'ENTRENADOR / EQUIPO')), m("table", {
      className: "Table PlayerTable"
    }, m("thead", null, m("tr", null, m("th", {
      className: "col-player"
    }, "ENTIDAD"), m("th", {
      className: "col-stat"
    }, "MEDIA REAL"), m("th", {
      className: "col-stat"
    }, "MEDIANA"), m("th", {
      className: "col-stat"
    }, "PARTIDOS"))), m("tbody", null, others.map(p => m("tr", {
      key: p.id(),
      onclick: () => this.showPlayerDetails(p),
      className: "PlayerTable-Row",
      style: "cursor: pointer;"
    }, m("td", {
      className: "col-player"
    }, m("div", {
      className: "PlayerTable-PlayerInfo"
    }, m("div", {
      className: "PlayerTable-Avatar"
    }, p.attribute('photoUrl') ? m("img", {
      src: p.attribute('photoUrl'),
      alt: p.attribute('name')
    }) : m("span", null, (p.attribute('name') || 'E')[0])), m("span", {
      className: "PlayerTable-Name"
    }, p.attribute('name'), m("span", {
      className: "entity-tag"
    }, app.translator.trans("nagusi-match-ratings.forum.stats.".concat(p.attribute('entityType'))))))), m("td", {
      className: "col-stat score"
    }, parseFloat(p.attribute('media') || 0).toFixed(2)), m("td", {
      className: "col-stat"
    }, parseFloat(p.attribute('mediana') || 0).toFixed(1)), m("td", {
      className: "col-stat"
    }, m("span", {
      className: "PlayerTable-Partidos"
    }, p.attribute('partidos') || 0)))))));
  }
  renderMatchesSection(matches) {
    const playedMatches = matches.filter(m => m.getScore() || m.attribute('matchDate') && new Date(m.attribute('matchDate')).getTime() < Date.now());
    const lastPlayed = playedMatches.length > 0 ? playedMatches[playedMatches.length - 1] : null;
    return m("div", {
      className: "Matches-Section"
    }, m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; flex-wrap: wrap; gap: 10px;"
    }, m("h3", {
      style: "font-weight: 800; border-left: 4px solid #EE2523; padding-left: 15px; margin: 0;"
    }, app.translator.trans('nagusi-match-ratings.forum.stats.matches')), lastPlayed && m(Button, {
      className: "Button Button--secondary",
      onclick: () => {
        const el = document.getElementById("rating-match-".concat(lastPlayed.id()));
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      },
      style: "border-radius: 20px; font-weight: bold; padding: 6px 14px; font-size: 13px;"
    }, m("i", {
      className: "fas fa-arrow-down",
      style: "margin-right: 6px;"
    }), "Ir al \xFAltimo partido disputado")), m("div", {
      className: "Matches-List"
    }, matches.map(match => this.renderMatchRow(match))));
  }
  renderMatchRow(match) {
    const matchId = match.id();
    const isExpanded = this.expandedMatches[matchId];
    const stats = this.matchVotes[matchId] || [];
    const isLoading = this.loadingMatchVotes[matchId];
    const rival = match.rival();
    const opponent = rival ? rival.name() : match.attribute('opponent') || '';
    const matchDate = match.attribute('matchDate');
    const voteCount = match.attribute('voteCount') || 0;
    return m("div", {
      className: "MatchRow-Card ".concat(isExpanded ? 'is-expanded' : ''),
      id: "rating-match-".concat(matchId),
      key: matchId,
      style: "background: #fff; border-radius: 12px; margin-bottom: 15px; box-shadow: 0 4px 6px rgba(0,0,0,0.03); border: 1px solid #eee; overflow: hidden;"
    }, m("div", {
      className: "MatchRow-Header",
      onclick: () => this.toggleMatch(matchId)
    }, m("div", {
      className: "MatchRow-Info"
    }, m("div", {
      className: "MatchRow-Title"
    }, match.renderName()), m("div", {
      className: "MatchRow-Meta"
    }, m("span", {
      className: "MatchRow-Date"
    }, m("i", {
      className: "far fa-calendar-alt MatchDate-Icon"
    }), " ", dayjs(matchDate).format('DD/MM/YYYY')), m("span", {
      className: "MatchRow-Votes"
    }, voteCount, " ", app.translator.trans('nagusi-match-ratings.forum.stats.votes')))), m("div", {
      className: "MatchRow-Toggle"
    }, m("i", {
      className: "fas ".concat(isExpanded ? 'fa-chevron-up' : 'fa-chevron-down')
    }))), isExpanded && m("div", {
      className: "MatchRow-Body",
      style: "padding: 20px; border-top: 1px solid #f0f0f0; background: #fafafa;"
    }, isLoading ? m("div", {
      style: "text-align: center; padding: 20px;"
    }, m(LoadingIndicator, null)) : stats.length > 0 ? m("div", {
      style: "display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 15px;"
    }, stats.map(s => m("div", {
      className: "Player-Match-Stats-Card",
      key: s.id(),
      style: "background: #fff; padding: 12px; border-radius: 10px; border: 1px solid #eee; display: flex; align-items: center; gap: 12px;"
    }, m("div", {
      style: "width: 40px; height: 40px; border-radius: 50%; overflow: hidden; border: 1px solid #ddd; flex-shrink: 0; background: #eee; display: flex; align-items: center; justify-content: center;"
    }, s.attribute('playerPhotoUrl') ? m("img", {
      src: s.attribute('playerPhotoUrl'),
      style: "width: 100%; height: 100%; object-fit: cover;"
    }) : m("span", {
      style: "font-weight: bold;"
    }, (s.attribute('playerName') || 'P')[0])), m("div", {
      style: "overflow: hidden;"
    }, m("div", {
      style: "font-weight: 700; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-size: 0.9em;"
    }, s.attribute('playerName')), m("div", {
      style: "display: flex; gap: 8px; margin-top: 4px;"
    }, m("div", {
      style: "background: #EE2523; color: #fff; padding: 0 6px; border-radius: 4px; font-size: 0.75em; font-weight: 800;"
    }, parseFloat(s.attribute('rating') || 0).toFixed(1)), m("div", {
      style: "background: #666; color: #fff; padding: 0 6px; border-radius: 4px; font-size: 0.75em; font-weight: 700;"
    }, parseFloat(s.attribute('median') || 0).toFixed(1))))))) : m("p", {
      style: "text-align: center; color: #999; padding: 20px;"
    }, m("i", {
      className: "fas fa-info-circle"
    }), " ", app.translator.trans('nagusi-match-ratings.forum.stats.no_votes'))));
  }
  toggleSort(column) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'desc';
    }
    this.playerStats.sort((a, b) => {
      let valA = a[column] || a.attribute(column) || 0;
      let valB = b[column] || b.attribute(column) || 0;
      if (typeof valA === 'string') {
        valA = parseFloat(valA);
        valB = parseFloat(valB);
      }
      if (valA < valB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valA > valB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
    m.redraw();
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/MatchStatsPage', MatchStatsPage);